// Structured logger — outputs only allowlisted operational metadata.
import { serializeScrubbedObservability } from "@alchema/shared";
import { safeLogMessage, scrubLoggerContext } from "~/lib/security/observability-policy";

type LogLevel = "info" | "warn" | "error";

interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  [key: string]: unknown;
}

function emit(level: LogLevel, message: string, context?: Record<string, unknown>): void {
  const safeContext = scrubLoggerContext(context);
  // Reserved fields are assigned last and cannot be overridden by context.
  const entry: LogEntry = {
    ...safeContext,
    level,
    message: safeLogMessage(message),
    timestamp: new Date().toISOString(),
  };

  const output = serializeScrubbedObservability(entry);

  switch (level) {
    case "error":
      console.error(output);
      break;
    case "warn":
      console.warn(output);
      break;
    default:
      console.log(output);
  }
}

export function logError(message: string, context?: Record<string, unknown>): void {
  emit("error", message, context);
}

export function logWarn(message: string, context?: Record<string, unknown>): void {
  emit("warn", message, context);
}

export function logInfo(message: string, context?: Record<string, unknown>): void {
  emit("info", message, context);
}
